import React, { useState } from "react";
import monoWebhookService from "../../../../services/_axiosServices/sweep/mono-webhook";
import { Loader, Error } from "../../components";

const initialData = [
  {
    institutionCode: "--",
    payload: "--",
    dateCreated: "--",
    id: 0,
  },
];

export default function Report() {
  const [loading, setLoading] = useState(false);
  const [id, setId] = useState("");
  const [data, setData] = useState(initialData);
  const [error, setError] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const fetchData = async () => {
    if (id.length < 1) {
      return;
    }

    setLoading(true);
    await monoWebhookService
      .retrieveById(id)
      .then((res: any) => {
        // console.log(res);
        setLoading(false);
        setData(res.data);
      })
      .catch((err: any) => {
        setError(true);
        setLoading(false);
        console.log(err.message);
      });
  };

  return (
    <div className="container-fluid relative animatedParent animateOnce">
      <div className="animated fadeInUpShort go">
        <div className="row my-3 mx-2">
          <h3>
            <b>Mono Webhook - Retrieve By ID</b>
          </h3>
        </div>
        <div className="card no-b">
          <div className="card-body">
            <div className="card-title">
              <div className="page">
                <div className="page-inner">
                  <div className="btn-toolbar justify-content-between">
                    <div className="btn-group">
                      <input
                        name="id"
                        onChange={(e) => setId(e.target.value)}
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="ID"
                        required
                      />
                      <button
                        type="button"
                        className="btn btn-sm btn-primary"
                        onClick={fetchData}
                      >
                        Go
                      </button>
                    </div>
                  </div>
                  <div className="table-responsive text-nowrap">
                    {loading && <Loader />}

                    {!loading && !error && (
                      <table className="table table-hover table-content table-striped table-bordered table-sm paged-output">
                        <thead>
                          <tr>
                            <th>id</th>
                            <th>institutionCode</th>
                            <th>payload</th>
                            <th>dateCreated</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.map((w: any, i: number) => (
                            <tr key={i}>
                              <td>{w.id}</td>
                              <td>{w.institutionCode}</td>
                              <td>{w.payload}</td>
                              <td>{w.dateCreated}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}

                    {error && !loading && <Error />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
